import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "jr-flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "jr-text-xs jr-mt-0.5" }, "(%)", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarChart = _resolveComponent("BarChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BarChart, _mergeProps({
      style: { height: `${_ctx.chartHeight}px` },
      class: "jr-flex-1"
    }, _ctx.barChartProps), null, 16, ["style"]),
    _hoisted_2
  ]))
}